<div class="row">
    <div class="col-1"></div>


    <div class="col-1"></div>
    @if(showPrintButton()) {
        <print-button [isLoading]="printLoading()" (click)="sendPrintPropertiesMessage()"></print-button>
    }
    <!-- <catalog-filters class="col" /> -->
</div>
